
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsPosPrinterGrid extends Serenity.EntityGrid<PsPosPrinterRow, any> {
        protected getColumnsKey() { return PsPosPrinterColumns.columnsKey; }
        protected getDialogType() { return PsPosPrinterDialog; }
        protected getIdProperty() { return PsPosPrinterRow.idProperty; }
        protected getInsertPermission() { return PsPosPrinterRow.insertPermission; }
        protected getLocalTextPrefix() { return PsPosPrinterRow.localTextPrefix; }
        protected getService() { return PsPosPrinterService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();
            
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );            
            return buttons;
        }
    }
}